import React, { useState } from "react";
import {
  Home, Layers, Receipt, BarChart2, Clock, Book, Calendar,
  Target, TrendingUp, MessagesSquare, Gift, HelpCircle,
  ChevronLeft, ChevronRight
} from "lucide-react";
import { NavLink } from "react-router-dom";

const navItems = [
  { name: "Dashboard", path: "/dashboard", icon: <Home size={20} /> },
  { name: "Accounts", path: "/accounts", icon: <Layers size={20} /> },
  { name: "Transactions", path: "/transactions", icon: <Receipt size={20} /> },
  { name: "Cash Flow", path: "/cashflow", icon: <BarChart2 size={20} /> },
  { name: "Reports", path: "/reports", icon: <Clock size={20} /> },
 
  { name: "Recurring", path: "/recurring", icon: <Calendar size={20} />, badge: 2 },
  { name: "Goals", path: "/goals", icon: <Target size={20} /> },
  { name: "Investments", path: "/investments", icon: <TrendingUp size={20} /> },
  { name: "Advice", path: "/advice", icon: <MessagesSquare size={20} /> },
];

const SIDEBAR_COLLAPSED = 55;
const SIDEBAR_EXPANDED = 200;

const Sidebar = () => {
  const [collapsed, setCollapsed] = useState(true);

  return (
    <>
      {/* Sidebar */}
      <aside
        className={`
          fixed top-0 left-0 h-screen z-40 bg-gray-900 border-r border-gray-700
          flex flex-col justify-between transition-all duration-300
        `}
        style={{
          width: collapsed ? SIDEBAR_COLLAPSED : SIDEBAR_EXPANDED,
        }}
      >
        {/* Top Section */}
        <div className="pt-6 pb-4 px-4 flex items-center">
          <span className="inline-flex items-center justify-center h-8 w-8 rounded-full bg-[#FF6B1C]">
            <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
              <circle cx="14" cy="14" r="14" fill="#FF6B1C" />
              <text
                x="50%"
                y="57%"
                textAnchor="middle"
                fontWeight="bold"
                fontSize="13"
                fill="white"
                fontFamily="Inter, sans-serif"
                dominantBaseline="middle"
              >
                CB
              </text>
            </svg>
          </span>
        </div>

        {/* Navigation */}
        <nav className="flex-1 mt-6">
          <ul className="flex flex-col gap-1">
            {navItems.map((item) => (
              <li key={item.path} className="relative group">
                <NavLink
                  to={item.path}
                  className={({ isActive }) =>
                    `flex items-center px-4 py-2 rounded-lg transition
                    ${isActive ? "bg-gray-800 text-white font-semibold" : "text-gray-300 hover:bg-gray-800"}
                    relative ${collapsed ? "justify-center px-3" : ""}`
                  }
                >
                  <span>{item.icon}</span>
                  {!collapsed && <span className="ml-3">{item.name}</span>}

                  {item.badge && !collapsed && (
                    <span className="ml-auto bg-[#FF6B1C] text-white text-xs font-bold px-2 py-0.5 rounded-lg">
                      {item.badge}
                    </span>
                  )}
                  {item.badge && collapsed && (
                    <span className="absolute top-2 right-2 bg-[#FF6B1C] text-white text-xs font-bold w-5 h-5 flex items-center justify-center rounded-full">
                      {item.badge}
                    </span>
                  )}
                </NavLink>

                {/* Tooltip */}
                {collapsed && (
                  <span
                    className="absolute left-full top-1/2 -translate-y-1/2 ml-2 whitespace-nowrap bg-black text-white text-xs font-medium px-2 py-1 rounded shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none z-50"
                  >
                    {item.name}
                  </span>
                )}
              </li>
            ))}
          </ul>
        </nav>

        {/* Footer */}
        <div className={`p-4 space-y-2 ${collapsed ? "px-2" : ""}`}>
          <button className={`w-full flex items-center gap-2 text-[#FF6B1C] text-sm font-semibold py-2 ${collapsed ? "justify-center" : ""}`}>
            <Gift size={18} />
            {!collapsed && <>Give 50% Get $50</>}
          </button>
          <button className={`w-full flex items-center gap-2 text-gray-400 text-sm py-2 ${collapsed ? "justify-center" : ""}`}>
            <HelpCircle size={18} />
            {!collapsed && <>Help & Support</>}
          </button>
        </div>
      </aside>

      {/* External Toggle Button (Top Right of Sidebar) */}
      <button
        onClick={() => setCollapsed(!collapsed)}
        className="fixed top-4 z-50 bg-gray-800 hover:bg-gray-700 text-white p-1 rounded-r-md shadow"
        style={{
          left: collapsed ? `${SIDEBAR_COLLAPSED}px` : `${SIDEBAR_EXPANDED}px`,
        }}
      >
        {collapsed ? <ChevronRight size={20} /> : <ChevronLeft size={20} />}
      </button>

      {/* Main Content */}
      <main
        className="min-h-screen transition-all duration-300 bg-gray-100"
        style={{ paddingLeft: collapsed ? SIDEBAR_COLLAPSED : SIDEBAR_EXPANDED }}
      >
        {/* Your content goes here */}
      </main>
    </>
  );
};

export default Sidebar;
